<template>
	<div class="country-choice">
		<bottom-sheet
			:ref="'bottomSheet'"
			:defaultState="'open'"
			v-if="canShowBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div class="country-choice__container">
				<h2>Choose your country</h2>
				<p v-if="selectedCountryCode.length > 0">
					We have noticed that you are in <b>{{ selectedCountry }}</b
					>. You could proceed with this option or switch to a different country
				</p>
				<p v-else>
					We could not detect your country. Please select one from the list
					below.
				</p>
				<div
					:class="[selectedCountryCode == country.code ? 'selected' : '']"
					class="country-choice__list"
					v-for="country in countries"
					:key="country.code"
					@click="updateSelectedCountry(country)"
				>
					<div class="country-choice__left">
						<img :src="country.imageSrc" :alt="country.name" width="25px" />
						<span class="country-choice__name">{{ country.name }}</span>
					</div>
					<div class="country-choice__right">
						<input
							class="country-choice__checkbox"
							type="checkbox"
							:checked="selectedCountryCode == country.code ? true : false"
						/>
						<span class="country-choice__checkmark"></span>
					</div>
				</div>
				<button @click="confirmCountry" class="country-choice__button">
					Proceed
				</button>
			</div>
		</bottom-sheet>
	</div>
</template>

<script>
import { setLocale } from "../../plugins/i18n";

export default {
	name: "CountrySelector",
	// props: ["selectedCountry", "selectedCountryCode"],
	props: {
		detectedCountryCode: String,
		detectedCountry: String,
	},
	data() {
		return {
			countries: [
				{
					code: "ET",
					name: "Ethiopia",
					defaultLocale: "am-et",
					imageSrc: "https://cdn.betika.com/country-flags/svg-src/ethiopia.svg",
				},
				{
					code: "KE",
					name: "Kenya",
					defaultLocale: "en-ke",
					imageSrc: "https://cdn.betika.com/country-flags/svg-src/kenya.svg",
				},
				{
					code: "GH",
					name: "Ghana",
					defaultLocale: "en-gh",
					imageSrc: "https://cdn.betika.com/country-flags/svg-src/ghana.svg",
				},
				{
					code: "NG",
					name: "Nigeria",
					defaultLocale: "en-ng",
					imageSrc: "https://cdn.betika.com/country-flags/svg-src/nigeria.svg",
				},
				{
					code: "UG",
					name: "Uganda",
					defaultLocale: "en-ug",
					imageSrc: "https://cdn.betika.com/country-flags/svg-src/uganda.svg",
				},
				{
					code: "MW",
					name: "Malawi",
					defaultLocale: "en-mw",
					imageSrc: "https://cdn.betika.com/country-flags/svg-src/malawi.svg",
				},
			],
			availableCountryCodes: ["KE", "GH", "NG", "ET", "UG", "MW"],
			confirmed: false,
			countryListOpen: false,
			country: "",
			canShowBottomSheet: true,
			selectedCountryCode: "",
			selectedCountry: "",
		};
	},
	mounted() {
		let vm = this;
		vm.selectedCountryCode = vm.detectedCountryCode;
		vm.selectedCountry = vm.detectedCountry;
	},
	methods: {
		confirmCountry() {
			let vm = this;
			let confirmedPayload = {
				countryCode: "",
				countryLocale: "",
			};
			// TODO: Set chosen country locale to be used as default locale
			if (
				vm.availableCountryCodes.includes(vm.selectedCountryCode.toUpperCase())
			) {
				confirmedPayload.countryCode = vm.selectedCountryCode;
				let countryDetails = vm.countries.find(
					(country) => country.code == vm.selectedCountryCode
				);
				confirmedPayload.countryLocale = countryDetails.defaultLocale;
			} else {
				confirmedPayload.countryCode = "KE";
				confirmedPayload.countryLocale = "en-ke";
			}
			localStorage.setItem(
				"countryCode",
				JSON.stringify(confirmedPayload.countryCode)
			);
			setLocale(confirmedPayload.countryLocale);
			// vm.$emit("countryConfirmed", confirmedPayload);

			this.$root.$emit("reset-sports-list"); // Reset sportslist for drop menu
			window.location.reload();
			vm.closeBottomSheet();
		},
		updateSelectedCountry(country) {
			let vm = this;
			vm.selectedCountryCode = country.code;
			vm.country = country.name;
			vm.countryListOpen = false;
		},
		closeBottomSheet() {
			let vm = this;
			vm.$refs.bottomSheet.setState("close");
			vm.$nextTick(() => {
				vm.canShowBottomSheet = false;
			});
		},
		showBottomSheet() {
			let vm = this;
			vm.canShowBottomSheet = true;
			vm.$nextTick(() => {
				vm.$refs.bottomSheet.setState("open");
			});
		},
	},
};
</script>
